import axios from "axios";
import Cookies from "js-cookie";

export const handleProducts = async (
  currentPage,
  searchQuery,
  selectedCat,
  selectedTags
) => {
  try {
    const token = Cookies.get("token");
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/getproducts",
      {
        limit: 30, // Number of records per page
        page: currentPage ?? 1, // Current page
        search_text: searchQuery,
        categories: selectedCat,
        tags: selectedTags,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    const data = await response.data;

    return data;
  } catch (error) {
    console.error("Error fetching web sections:", error);
    return null;
  }
};

export const handleCategoriesTags = async () => {
  try {
    const token = Cookies.get("token");
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/getCategoriesAndTags",
      {},
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (response.status !== 200) {
      throw new Error("Network response was not ok");
    }

    const data = await response.data;

    return data;
  } catch (error) {
    console.error("Error fetching web sections:", error);
    return null;
  }
};
